import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import talentTemplate from '@/views/talentTemplate'
import projectPlate from '@/views/projectPlate'
import consultant from '@/views/consultant'
import news from '@/views/news'
import aboutUs from '@/views/aboutUs'
import juvenileStage from '@/views/phaseList/juvenileStage'	//少年阶段
import youngStage1 from '@/views/phaseList/youngStage1'	//青年阶段
import youngStage2 from '@/views/phaseList/youngStage2'	//青年阶段
import youngStage3 from '@/views/phaseList/youngStage3'	//青年阶段
import adultStage from '@/views/phaseList/adultStage'	//青年阶段
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/talentTemplate',
      name: 'talentTemplate',
      component: talentTemplate
    },
    {
      path: '/juvenileStage',
      name: 'juvenileStage',
      component: juvenileStage
    },
    {
      path: '/youngStage1',
      name: 'youngStage1',
      component: youngStage1
    },
    {
      path: '/youngStage2',
      name: 'youngStage2',
      component: youngStage2
    },
    {
      path: '/youngStage3',
      name: 'youngStage3',
      component: youngStage3
    },
    {
      path: '/adultStage',
      name: 'adultStage',
      component: adultStage
    },
     {
      path: '/projectPlate',
      name: 'projectPlate',
      component: projectPlate
    },
    {
      path: '/consultant',
      name: 'consultant',
      component: consultant
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js